import React, { useContext } from 'react';
import { IoIosArrowDown } from 'react-icons/io';
import { Container, Title, Arrow, Button } from './styles/SearchEventBar.styled';
import EventSearchBarContext from '../context/SearchEventContext';

export default function SearchEventBar({ title, dir }) {
  const { displayMenu, setDisplayMenu } = useContext(EventSearchBarContext);

  return (
    <Container clicked={displayMenu} id="searchEventBar_1">
      <Button onClick={() => setDisplayMenu(!displayMenu)} dir={dir}>
        <Title dir={dir}>{title}</Title>
        <Arrow clicked={displayMenu} dir={dir}>
          <IoIosArrowDown className="arrow" />
        </Arrow>
      </Button>
    </Container>
  );
}
